import algoliasearch from "algoliasearch";

export const initIndex = (appId, apiKey, indexName) =>
  algoliasearch(appId, apiKey).initIndex(indexName);

export const index = initIndex(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_API_KEY,
  process.env.REACT_APP_ALGOLIA_INDEX_NAME,
);
